// auth.js
export const AUTH_CLEAR_USER = 'CLEAR_USER'
export const AUTH_UPDATE_USER = 'UPDATE_USER'
export const AUTH_UPDATE_USER_ACCOUNT_BALANCE = 'UPDATE_ACCOUNT'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// messages.js
export const SET = 'SET'
export const CLEAR = 'CLEAR'

// cache.js
export const PUT = 'PUT'

// settings.js
export const SETTINGS_SET = 'SET'
